import {useAtom} from "jotai";
import {ScoutingNoteComponent} from "../scoutingNotes/scoutingNote";
import {activeMapFeatureAtom} from "../../store/activeMapFeatureStore";
import {Suspense} from "react";

export const BaseContextPanel: React.FC = () => {
    const [activeMapFeature] = useAtom(activeMapFeatureAtom);
    return activeMapFeature ? (
        <Suspense>
            <ScoutingNoteComponent />
        </Suspense>
    ) : (
        <div></div>
    );
};
